import { tv } from "../../variants/tv.js";
const mediaCardVariants = tv({
    slots: {
        rootSlot: 'flex flex-col',
        clickableSlot: 'group relative block w-full cursor-pointer rounded-xl bg-primary-1 focus-visible:ring-2 focus-visible:ring-actionSecondary-12 focus-visible:ring-offset-2 focus-visible:outline-none',
        mediaWrapperSlot: 'relative aspect-[288/162] w-full overflow-hidden rounded-xl transition-shadow group-hover:shadow-xl',
        mediaImageSlot: 'fill-mode-forwards absolute inset-0 h-full w-full',
        overlaysSlot: 'pointer-events-none absolute flex min-h-1 flex-row items-center justify-start',
        logoImgSlot: '',
        badgeSlot: 'flex p-3',
        adSlot: 'absolute top-3 right-3 flex flex-row items-center',
        contentSlot: 'flex flex-col gap-1 pt-3',
        eyebrowSlot: 'text-left',
        headingSlot: 'flex flex-col gap-1 text-left',
        bodySlot: 'text-left',
        ctaSlot: 'flex flex-col items-start pt-1',
        promoSlot: 'pt-3'
    },
    variants: {
        logoPosition: {
            topLeft: {
                overlaysSlot: 'inset-x-0 top-0 h-fit'
            },
            center: {
                logoImgSlot: 'absolute inset-0 flex items-center justify-center',
                overlaysSlot: 'inset-0'
            }
        },
        hasLogoForBadge: {
            true: {
                badgeSlot: 'left-auto'
            },
            false: {}
        }
    },
    defaultVariants: {
        logoPosition: 'topLeft',
        hasLogoForBadge: false
    }
});
export { mediaCardVariants };
